export function notification(text: string, type: string = 'success') {
  console.log(text, { appearance: 'error' });
}
